module.exports = __webpack_public_path__ + "static/media/warning-icon.53312179.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/warning-icon.svg
// module id = 1569
// module chunks = 0